document.addEventListener('DOMContentLoaded', function () {
  try {
    const isLogged = !!window.customerLoggedIn;
    const isB2BCustomer = !!window.customerIsB2B;
    const shouldInterceptAtc = !isB2BCustomer;

    // If customer just logged in and we have a return URL, redirect
    if (isLogged && localStorage.getItem('b2b_return_to')) {
      const returnTo = localStorage.getItem('b2b_return_to');
      localStorage.removeItem('b2b_return_to');
      if (returnTo && returnTo !== location.href) {
        location.href = returnTo;
        return;
      }
    }

    const modal = document.getElementById('b2b-login-modal');
    if (!modal) return;

    const overlay = modal.querySelector('.b2b-login-modal__overlay');
    const closeBtn = modal.querySelector('.b2b-login-modal__close');
    const primary = modal.querySelector('[data-b2b-primary]');
    const secondary = modal.querySelector('[data-b2b-secondary]');
    const buyNowLabel = window.b2bBuyNow || 'jetzt kaufen';
    const loginUrl = window.b2bLoginUrl || '/account/login';

    let isLoggedInNonB2BMode = false;

    // Replace ATC button text for anyone who cannot add to cart (non-B2B)
    if (shouldInterceptAtc) {
      document
        .querySelectorAll('[data-b2b-atc="true"]')
        .forEach(function (btn) {
          if (!btn.dataset.b2bOriginalHtml)
            btn.dataset.b2bOriginalHtml = btn.innerHTML;

          // try to preserve loader if present
          const loader = btn.querySelector('.button__loader');
          if (loader) {
            loader.remove();
            btn.innerHTML = '<div>' + buyNowLabel + '</div>';
            btn.appendChild(loader);
          } else {
            const firstDiv = btn.querySelector('div');
            if (firstDiv) firstDiv.textContent = buyNowLabel;
            else btn.textContent = buyNowLabel;
          }
          btn.setAttribute('aria-label', buyNowLabel);
        });
    }

    function openModal(mode = 'default') {
      isLoggedInNonB2BMode = mode === 'logged-in-non-b2b';

      // Update modal content based on mode
      updateModalContent(mode);

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');

      // focus the appropriate button
      if (isLoggedInNonB2BMode) {
        if (secondary) secondary.focus();
      } else {
        if (primary) primary.focus();
      }

      document.documentElement.style.overflow = 'hidden';
    }

    // Helper function to darken a hex color
    function darkenColor(hex, percent) {
      if (!hex) return hex;
      hex = hex.replace('#', '');
      const num = parseInt(hex, 16);
      const r = Math.max(0, Math.floor((num >> 16) * (1 - percent / 100)));
      const g = Math.max(
        0,
        Math.floor(((num >> 8) & 0x00ff) * (1 - percent / 100))
      );
      const b = Math.max(0, Math.floor((num & 0x0000ff) * (1 - percent / 100)));
      return '#' + (b | (g << 8) | (r << 16)).toString(16).padStart(6, '0');
    }

    // Helper function to determine if a color is dark (needs white text)
    function isColorDark(hex) {
      if (!hex) return false;
      hex = hex.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      // Calculate relative luminance using sRGB formula
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance < 0.5;
    }

    function updateModalContent(mode) {
      const title = modal.querySelector('#b2b-login-modal__title');
      const body = modal.querySelector('.b2b-login-modal__body');

      if (mode === 'logged-in-non-b2b') {
        // Update title for logged-in non-B2B users
        if (title && window.b2bLoggedInHeadline) {
          title.textContent = window.b2bLoggedInHeadline;
        }

        // Update body text for logged-in non-B2B users
        if (body && window.b2bLoggedInDescription) {
          body.textContent = window.b2bLoggedInDescription;
        }

        // Hide primary button
        if (primary) primary.style.display = 'none';

        // Apply custom styles to secondary button for logged-in non-B2B mode
        if (secondary) {
          const bgColor = window.b2bLoggedInSecondaryBg;
          const borderColor = window.b2bLoggedInSecondaryBorder;
          const hoverBgColor = darkenColor(bgColor, 15);

          if (bgColor) {
            secondary.style.backgroundColor = bgColor;
            // Set text color based on background darkness for readability
            secondary.style.color = isColorDark(bgColor) ? '#ffffff' : '';
          }
          if (borderColor) {
            secondary.style.borderColor = borderColor;
          }

          // Store original handlers and add custom hover behavior
          secondary.dataset.loggedInNonB2B = 'true';
          secondary.dataset.bgColor = bgColor || '';
          secondary.dataset.hoverBgColor = hoverBgColor || '';
        }
      } else {
        // Default mode - show primary button
        if (primary) primary.style.display = '';

        // Reset secondary button to default styles
        if (secondary) {
          secondary.style.backgroundColor = '';
          secondary.style.borderColor = '';
          secondary.style.color = '';
          secondary.dataset.loggedInNonB2B = '';
          secondary.dataset.bgColor = '';
          secondary.dataset.hoverBgColor = '';
        }
      }
    }

    // Handle hover states for secondary button in logged-in non-B2B mode
    if (secondary) {
      // Store original color for reset
      const originalTextColor = getComputedStyle(secondary).color;

      secondary.addEventListener('mouseenter', function () {
        if (
          this.dataset.loggedInNonB2B === 'true' &&
          this.dataset.hoverBgColor
        ) {
          this.style.backgroundColor = this.dataset.hoverBgColor;
          // Set text color based on hover background darkness for readability
          this.style.color = isColorDark(this.dataset.hoverBgColor)
            ? '#ffffff'
            : originalTextColor;
          if (window.b2bLoggedInSecondaryBorder) {
            this.style.borderColor = darkenColor(
              window.b2bLoggedInSecondaryBorder,
              15
            );
          }
        }
      });

      secondary.addEventListener('mouseleave', function () {
        if (this.dataset.loggedInNonB2B === 'true' && this.dataset.bgColor) {
          this.style.backgroundColor = this.dataset.bgColor;
          // Reset text color based on original background darkness
          this.style.color = isColorDark(this.dataset.bgColor)
            ? '#ffffff'
            : originalTextColor;
          if (window.b2bLoggedInSecondaryBorder) {
            this.style.borderColor = window.b2bLoggedInSecondaryBorder;
          }
        }
      });
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    // delegates clicks on ATC buttons
    document.addEventListener('click', function (ev) {
      const btn = ev.target.closest('[data-b2b-atc="true"]');
      if (!btn) return;
      if (!shouldInterceptAtc) return; // allow normal behavior for B2B customers

      ev.preventDefault();

      // Check if this is a logged-in non-B2B user
      if (isLogged && !isB2BCustomer) {
        openModal('logged-in-non-b2b');
      } else {
        openModal('default');
      }
    });

    // delegates clicks on account links for non-logged-in users
    document.addEventListener('click', function (ev) {
      const accountLink = ev.target.closest('[data-b2b-account-login="true"]');
      if (!accountLink) return;
      if (isLogged) return; // allow normal behavior for logged-in users

      ev.preventDefault();
      openModal('default');
    });

    // primary -> go to login (store return URL)
    if (primary) {
      primary.addEventListener('click', function () {
        try {
          localStorage.setItem('b2b_return_to', location.href);
        } catch (e) {}
        location.href = loginUrl;
      });
    }

    // secondary -> close modal, clear minimized session storage, and redirect to form URL
    if (secondary) {
      secondary.addEventListener('click', function () {
        closeModal();

        // Clear localStorage items containing "minimized-in-session"
        try {
          const keysToRemove = [];
          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.includes('minimized-in-session')) {
              keysToRemove.push(key);
            }
          }
          keysToRemove.forEach((key) => localStorage.removeItem(key));
        } catch (e) {
          // Silently fail if localStorage access fails
        }

        // Open the form URL in a new tab (use current page if no form URL is set)
        const formUrl = window.b2bFormUrl || window.location.href;
        window.open(formUrl, '_blank');
      });
    }

    // close handlers
    if (overlay) overlay.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') closeModal();
    });
  } catch (err) {
    // fail silently
    console.error('B2B modal error', err);
  }
});
